<template>
  <form>
    <h3>Add new theme:</h3>

    <div class="form-group row">
      <label class="col-sm-3">Theme name</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="newTheme.name">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3">Description</label>
      <div class="col-sm-9">
        <textarea type="text" class="form-control" rows="5" v-model="newTheme.description"></textarea>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3">Slug</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="newTheme.slug">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3">Price</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="newTheme.price">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3">Tags</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="newTheme.tags">
      </div>
    </div>

    <hr />

    <p><strong>Options</strong></p>
    <div class="form-group row">
      <label class="col-sm-3">Text field 1</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="newTheme.options[0].textInput1">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3">Text field 2</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="newTheme.options[0].textInput2">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3">Date</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" v-model="newTheme.options[0].date">
      </div>
    </div>

    <!-- <div class="form-group row">
      <label class="col-sm-3">Image 1</label>
      <div class="col-sm-9">
        <input type="file" class="form-control" name="fileToUpload" id="fileToUpload">
        <input type="submit" class="form-control" value="Upload Image" name="submit">
      </div>
    </div> -->

    <div class="form-group row">
      <button type="button" class="btn btn-success btn-block" @click="addTheme">Add</button>
    </div>

  </form>
</template>

<script>
import { dbThemesRef } from '../firebaseConfig'

  export default {
    data() {
      return {
        newTheme: {
          'name': 'Purple Maze',
          'description': 'Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur',
          'slug': 'purple-maze',
          'price': 9.99,
          'tags': 'wedding',
          'options': [{
            'textInput1': 'My Wedding',
            'textInput2': 'Milwakee',
            'date': 'July 22, 2018',
            'image1': 'image.jpg'
          }]
        }
      }
    },
    methods: {
      addTheme() {
        dbThemesRef.push(this.newTheme)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/NewTheme.vue